module.exports = __webpack_public_path__ + "img/OnArchitecture4.51207ed0.jpg";